import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const UserDifTask = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default UserDifTask
